import { useEffect, useState } from "react";
import { Button, ButtonGroup } from "reactstrap";
import PropTypes from "prop-types";

const OptionButton = ({ options, value, onChange }) => {
  const [selected, setSelected] = useState(value);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  return (
    <ButtonGroup>
      {Object.entries(options).map(([key, value]) => (
        <Button
          key={key}
          color="primary"
          active={selected === key}
          onClick={() => {
            setSelected(key);
            if (typeof onChange === "function") onChange(key);
          }}
        >
          {value}
        </Button>
      ))}
    </ButtonGroup>
  );
};

OptionButton.propTypes = {
  options: PropTypes.object.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func
};

export default OptionButton;
